/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleDetailModel } from '../../models/article-detail-model';

export interface ArticlePublisherIdIdHtmlArticleLanguageIdPost$Json$Params {
  publisherId: string;
  id: string;
  languageId: string;
      body?: ArticleDetailModel
}

export function articlePublisherIdIdHtmlArticleLanguageIdPost$Json(http: HttpClient, rootUrl: string, params: ArticlePublisherIdIdHtmlArticleLanguageIdPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, articlePublisherIdIdHtmlArticleLanguageIdPost$Json.PATH, 'post');
  if (params) {
    rb.path('publisherId', params.publisherId, {});
    rb.path('id', params.id, {});
    rb.path('languageId', params.languageId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<string>;
    })
  );
}

articlePublisherIdIdHtmlArticleLanguageIdPost$Json.PATH = '/Article/{publisherId}/{id}/HtmlArticle/{languageId}';
